import PdfReader from '../GenericComponent/PdfReader';
export default {
  pdfReader: {
    screen: PdfReader,
  },
};
